import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-logout",
  "use": "foquz-icon-vue-logout-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-logout\"><path d=\"M7 14H4.333A1.334 1.334 0 013 12.667V3.333A1.333 1.333 0 014.333 2H7m4.667 9.333L15 8m0 0l-3.333-3.333M15 8H7\" stroke=\"#679\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol